import { useContext } from 'react'
import useSWR from 'swr'

import { AppContext } from '../components/AppContext/AppContext'
import { fetcher } from '../utils'

export type RewardsApiResponse = {
  esMETBalance: string
  lpBalance: string
  synthBalance: string
  esMETTotalSupply: string
  lpTotalSupply: string
  synthTotalSupply: string
  totalBoost: string
  rewardsPercent: string
}

function useBoostedRewards() {
  const {
    state: {
      wallet: { account }
    }
  } = useContext(AppContext)

  const { data } = useSWR<RewardsApiResponse, Error>(
    account ? `/api/rewards/${account}` : 'null',
    account ? fetcher : () => Promise.resolve({}),
    {
      fallbackData: {
        esMETBalance: '0',
        esMETTotalSupply: '0',
        lpBalance: '0',
        lpTotalSupply: '0',
        rewardsPercent: '0',
        synthBalance: '0',
        synthTotalSupply: '0',
        totalBoost: '0'
      },
      refreshInterval:
        parseInt(process.env.NEXT_PUBLIC_REFRESH_INTERVAL) * 1000,
      revalidateOnMount: true
    }
  )

  return data
}

export default useBoostedRewards
